<template>
  <div class="home--machine bg__whiteAbs">
    <div class="ly--content--container">
      <div
        class="h1 text-center txt-upper mB48 section__title home--machine__video--title"
        v-html="$t('machine.title')"
      ></div>
      <div class="home--machine__video">
        <iframe
          src="https://www.youtube.com/embed/WovaJ9Ysk40?si=ddFseyjzkvsvpNTb"
          title='Nespresso – 臻選厚萃咖啡| VERTUO POP膠囊咖啡機，全新上市| TW - 繽紛多色篇 30" | TW'
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeMachine",
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  .home--machine {
    padding: rem(40) 0;

    &__video {
      aspect-ratio: 710/400 * 1;
      border-radius: rem(10);
      overflow: hidden;
      iframe {
        width: 100%;
        height: 100%;
      }

      &--title {
        @include media-breakpoint-down(md) {
          margin-bottom: rem(16) !important;
        }
      }
    }
  }
}
</style>
